export default __webpack_public_path__ + "static/media/buysellss.e96d019e.png";